"use strict";

const Popout = () => {
    const init = () => {
        $(function() {
            var $popout = $('.js-popout');
            var $anchorPopup = $('a[href^="#"]')
            var $popoutTriggers = $('.js-popout-trigger');

            window.resetPopoutTriggers = function(){
                var $popoutTriggers = $('.js-popout-trigger');
                
                $popoutTriggers.off('click');
                $popoutTriggers.on('click', function(){
                    togglePopup($(this).data('popout'));
                    if($(this).data('download')){
                        var $downloadForm = $popout.filter('[data-hash="'+ $(this).data('popout') +'"]').find('.js-download-form');
                        if($downloadForm.length){
                            $downloadForm.data('download', $(this).data('download'));
                        }
                    }

                    if($(this).data('houseland')){
                        $popout.filter('.js-popout[data-hash="'+ $(this).data('popout') +'"]').find('[name="houseland"]').val($(this).data('houseland'));
                    }

                    if($(this).filter('[data-popout^="inclusions-comparison-popout"]')){
                        $popoutTriggers.filter('[data-popout^="inclusions-comparison-popout"]').removeClass('active');
                        $popoutTriggers.filter('[data-popout^="'+$(this).data('popout')+'"]').addClass('active');
                    }
                    refreshSelectSections();
                });

                $anchorPopup.off('click')
                $anchorPopup.on('click', function() {
                    var $hash = $(this).attr('href').replace('#', '')
                    togglePopup($hash);
                })
            }

            const togglePopup = (hash) => {
                if($popout.filter('[data-hash="'+ hash +'"]').hasClass('open')){
                    $popout.removeClass('open');
                    $popoutTriggers.removeClass('active');
                    $('body').css('overflow', '');
                }else{
                    $popout.removeClass('open');
                    $popoutTriggers.removeClass('active');
                    $popout.filter('[data-hash="'+ hash +'"]').addClass('open');
                    $popoutTriggers.filter('[data-popout="'+ hash +'"]').addClass('active');
                    $('body').css('overflow', 'hidden');
                }
            }

            resetPopoutTriggers();
            
            $popout.find('.js-popout-close').on('click', function(){
                $popout.removeClass('open');
                $popoutTriggers.removeClass('active');
                $('body').css('overflow', '');
                $popoutTriggers.filter('[data-popout^="inclusions-comparison-popout"]').removeClass('active');
            });
            
            window.openPopout = function($this){
                togglePopup($this.data('popout'));
                if($this.data('download')){
                    var $downloadForm = $popout.filter('[data-hash="'+ $this.data('popout') +'"]').find('.js-download-form');
                    if($downloadForm.length){
                        $downloadForm.data('download', $this.data('download'));
                    }
                }
            }
            
            window.closePopout = function(){
                $('.js-popout').removeClass('open');
                $popoutTriggers.removeClass('active');
                $('body').css('overflow', '');
                $popoutTriggers.filter('[data-popout^="inclusions-comparison-popout"]').removeClass('active');
            };
        });
    };

    return {
        init:init
    };
};

export default Popout;